module.exports = __webpack_public_path__ + "img/Airbnb-Work-From-Home-Seating2-1-scaled.6c8a0610.jpg";